import { useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import useLocales from "src/hooks/useLocales";
import { isValidToken } from "src/utils/jwt";
import SnackbarUtils from "src/utils/SnackbarUtils";

import Context from "../../../../context";

export default function useOnRepeatDemo() {
	const { translate } = useLocales();
	const { actions } = useContext(Context);
	const queryClient = useQueryClient();

	const onRepeatDemo = () => {
		const sessionToken = queryClient.getQueryData<string>(["demo", "sesion"]);

		queryClient.removeQueries({ queryKey: ["demo", "data"] });

		if (sessionToken && isValidToken(sessionToken)) {
			actions.onSetSessionToken(sessionToken);
		} else {
			queryClient.removeQueries({ queryKey: ["demo", "sesion"] });
			actions.setStep(0);
			SnackbarUtils.error(translate("Sesión caducada."));
		}
	};

	return { onRepeatDemo };
}
